export default {
  search: {
    label: 'Search',
    placeholder: 'Search by task name',
    system: {
      name: 'search',
    },
    style: {
      title: {
        bold: true,
      },
    },
    value: '',
    errors: [],
    type: 'search',
    name: 'search',
    key: 'search-dashboard',
    rules: {
      title: '',
      required: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/fields.js